/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2020] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Ladda = require('ladda');
var Radio = require('backbone.radio');

var parsleyUtil = require('common/util/parsleyUtil');

var tmplCOCEventSubmissionView = require('../templates/COCEventSubmissionView.hbs');
var CreateNewEvent = require('../services/CreateNewEvent');

module.exports = Marionette.LayoutView.extend({
  template: tmplCOCEventSubmissionView,

  className: 'coc-event-submission-view',

  ui: {
    submissionForm: '.submission-form',
    submit: '.submit',
    validationErrors: '.validation-errors',
    validationErrorSections: '.validation-error-sections'
  },

  events: {
    'click @ui.submit': 'onClickSubmit'
  },

  onClickSubmit: function(e) {
    e.preventDefault();
    var self = this;
    this.ui.validationErrors.hide();
    var l = Ladda.create(this.ui.submit[0]);

    this.sideNavView
      .validateAll({ type: 'submit' })
      .done(function() {
        l.start();
        var formData = self.sideNavView.getFormData();
        CreateNewEvent(formData)
          .done(function(event) {
            l.stop();
            Radio.channel('navigate').trigger('show:int:coc:event', event.eventId);
          })
          .fail(function() {
            l.stop();
          });
      })
      .fail(function() {
        l.stop();
        var errors = self.sideNavView.getSectionTitlesWithErrors();
        self.ui.validationErrorSections.empty();
        self.ui.validationErrorSections.append(errors.join('<br/>'));
        self.ui.validationErrors.show();
      });
  },

  validate: function(config) {
    this.ui.submissionForm.parsley().reset();
    if (config.type === 'save') {
      // Turn off required field validation for this form
      parsleyUtil.disableRequiredValidation(this.ui.submissionForm);
    } else {
      // Turn on required field validation for this form
      parsleyUtil.enableRequiredValidation(this.ui.submissionForm);
    }
    return this.ui.submissionForm.parsley().whenValidate();
  }
});
